import { render } from "./PageNotFound.vue?vue&type=template&id=3d313e1f"
const script = {}

import exportComponent from "/home/runner/work/agradata/agradata/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__